import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Box,
  AppBar,
  Toolbar,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AccountCircle, Lock } from "@mui/icons-material";
import axios from "axios";

const CustomerLogin = () => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://sakhisshop.com/api/customers/login",
        credentials,
      );

      if (response.status === 200) {
        alert("Login Successful!");
        const customerId = response.data.cID;

        if (customerId) {
          localStorage.setItem("customerID", customerId);
          navigate("/customer-dashboard");
        } else {
          setError("Invalid login.");
        }
      }
    } catch (error) {
      setError("Invalid Username or Password");
    }
  };

  return (
    <>
      {/* AppBar */}
      {/* <AppBar
        position="fixed"
        sx={{
          background: "linear-gradient(to right, #6a1b9a, #4a148c)",
          zIndex: 1300,
        }}
      >
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: "bold" }}>
            🛒 MyShop Management System
          </Typography>
        </Toolbar>
      </AppBar> */}

      {/* Login Box */}
      <Box
        sx={{
          minHeight: "100vh",
          pt: 10, // padding top for AppBar
          pb: 8, // padding bottom for Footer
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "url('https://t4.ftcdn.net/jpg/05/71/83/47/360_F_571834789_ujYbUnH190iUokdDhZq7GXeTBRgqYVwa.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(8px)",
          },
        }}
      >
        <Container maxWidth="sm" sx={{ position: "relative", zIndex: 2 }}>
          <Paper
            elevation={10}
            sx={{
              p: 5,
              borderRadius: 4,
              background: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              textAlign: "center",
              color: "#fff",
              padding: isMobile ? 3 : 5,
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              gutterBottom
              sx={{
                fontWeight: "bold",
                mb: 3,
                color: "white",
                fontFamily: "revert-layer",
                fontWeight: "800px",
              }}
            >
              Customer Login
            </Typography>

            <form onSubmit={handleLogin}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                variant="outlined"
                value={credentials.username}
                onChange={handleChange}
                required
                sx={{
                  mb: 3,
                  bgcolor: "rgba(255,255,255,0.2)",
                  borderRadius: 2,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                  sx: { color: "#fff" },
                }}
                InputLabelProps={{ style: { color: "#fff" } }}
              />

              <TextField
                fullWidth
                type="password"
                label="Password"
                name="password"
                variant="outlined"
                value={credentials.password}
                onChange={handleChange}
                required
                sx={{
                  mb: 2,
                  bgcolor: "rgba(255,255,255,0.2)",
                  borderRadius: 2,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                  sx: { color: "#fff" },
                }}
                InputLabelProps={{ style: { color: "#fff" } }}
              />

              {error && (
                <Typography color="error" sx={{ mb: 2 }}>
                  {error}
                </Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  mt: 2,
                  py: 1.2,
                  fontWeight: "bold",
                  borderRadius: 3,
                  background: "linear-gradient(135deg, #6a1b9a, #4a148c)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #4a148c, #2e0854)",
                  },
                }}
              >
                Login
              </Button>
            </form>
          </Paper>
        </Container>
      </Box>

      {/* Footer */}
      {/* <Box
        component="footer"
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          py: 2,
          textAlign: "center",
          background: "linear-gradient(to right, #6a1b9a, #4a148c)",
          color: "#fff",
        }}
      >
        <Typography variant="body2">© 2025 MyShop Customer Portal</Typography>
      </Box> */}
    </>
  );
};

export default CustomerLogin;
